import { render, staticRenderFns } from "./EntradasTable.vue?vue&type=template&id=6f92e522&scoped=true"
import script from "./EntradasTable.vue?vue&type=script&lang=ts"
export * from "./EntradasTable.vue?vue&type=script&lang=ts"
import style0 from "./EntradasTable.vue?vue&type=style&index=0&id=6f92e522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f92e522",
  null
  
)

export default component.exports